module.exports = __webpack_public_path__ + "img/bus-fill-green.5fa377f2.svg";